import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

export const DateHeaderContainer = styled.span<{ $isToday: boolean }>`
  ${({ theme }) => typographyToCss(theme.typography.body2)};
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};

  color: ${({ theme }) => theme.palette.text.secondary};

  ${({ $isToday, theme }) =>
    $isToday &&
    css`
      color: ${theme.palette.text.primary};
    `};
`;
